__turbopack_context__.v({
  "card": "WorkExperienceCard-module-scss-module__pW8VWa__card",
  "company": "WorkExperienceCard-module-scss-module__pW8VWa__company",
  "companyLink": "WorkExperienceCard-module-scss-module__pW8VWa__companyLink",
  "companyRow": "WorkExperienceCard-module-scss-module__pW8VWa__companyRow",
  "currentBadge": "WorkExperienceCard-module-scss-module__pW8VWa__currentBadge",
  "header": "WorkExperienceCard-module-scss-module__pW8VWa__header",
  "headerLeft": "WorkExperienceCard-module-scss-module__pW8VWa__headerLeft",
  "highlight": "WorkExperienceCard-module-scss-module__pW8VWa__highlight",
  "highlights": "WorkExperienceCard-module-scss-module__pW8VWa__highlights",
  "logoCard": "WorkExperienceCard-module-scss-module__pW8VWa__logoCard",
  "meta": "WorkExperienceCard-module-scss-module__pW8VWa__meta",
  "metaIcon": "WorkExperienceCard-module-scss-module__pW8VWa__metaIcon",
  "metaItem": "WorkExperienceCard-module-scss-module__pW8VWa__metaItem",
  "pulseGlow": "WorkExperienceCard-module-scss-module__pW8VWa__pulseGlow",
  "role": "WorkExperienceCard-module-scss-module__pW8VWa__role",
  "techPill": "WorkExperienceCard-module-scss-module__pW8VWa__techPill",
  "techRow": "WorkExperienceCard-module-scss-module__pW8VWa__techRow",
});
